module.exports = __webpack_public_path__ + "static/businessCardsDesktop@2x-bc8c1044d6ba6c29d461dc9c6896ed9d.png";